<template>
  <div class="v-table-td-credit">
    <v-table-number ref="numberRef" field="creditAmount" :rowIndex="rowIndex" @onEnter="onEnter" @cancel-edit="cancelEdit" :number="number"/>
  </div>
</template>
<script setup>
import VTableNumber from "@components/VoucherTable/VTableNumber.vue";
import {defineExpose, getCurrentInstance, onMounted, ref, watch} from "vue";
import {getVTable} from "@components/VoucherTable/VtUtil";
import {divide, round} from "xe-utils";

const props = defineProps(['credit', 'rowIndex', 'detail']);

const number = ref(null)
const numberRef = ref(null)
let VTable = null;

const cancelEdit = (numVal) => {
	console.log("取消录入")
	number.value = numVal;
	// props.detail.price = round(divide(numVal, props.detail.num), 6);//这里的单价应该放开所有小数位限制，直接开到6
	if((numVal != 0 && props.detail.num != 0) && (props.detail.num != null && numVal != null)){
		props.detail.price = round(divide(numVal, props.detail.num), 6);//这里的单价应该放开所有小数位限制，直接开到6
	}

    //jxd有汇率，算原币，有原币算汇率,两个都有算汇率
	//如果没有本币，有汇率和原币，算本币
	//之前就是汇率必须有，单算原币props.detail.amountFor = round(divide(numVal, props.detail.exchangeRate), 2);
	if(props.detail.exchangeRate && props.detail.amountFor){
		props.detail.exchangeRate = round(divide(numVal, props.detail.amountFor), 4);
	}else if(props.detail.exchangeRate){
		props.detail.amountFor = round(divide(numVal, props.detail.exchangeRate), 2);
	}else if(props.detail.amountFor){
		props.detail.exchangeRate = round(divide(numVal, props.detail.amountFor), 4);
	}
  
  props.detail.creditAmountFor = props.detail.amountFor;
  props.detail.creditNum = props.detail.num;
  props.detail.debitNum = 0;
	VTable.exposed.updateFiled(props.rowIndex, 'creditAmount', numVal);
	VTable.exposed.updateFiled(props.rowIndex, 'creditAmountFor', props.detail.amountFor);
}

const onEnter = () => {
	cancelEdit();
	VTable.exposed.next(props.rowIndex + 1, 'summary');
}

watch(() => props.credit, (val) => {
	number.value = val;
})

onMounted(() => {
	VTable = getVTable(getCurrentInstance())
	number.value = props.credit;
})

defineExpose({
	doEdit: () => numberRef.value.doEdit(),
	endEdit: () => numberRef.value.cancelEdit()
})
</script>
<style scoped lang="less">
.v-table {

  &-td {
    &-credit {
      width: 221px;
      background-image: url("../../assets/moneyUint.png");
    }
  }
}
</style>
